import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { object, string } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import './TopInformation.scss';
import { ANIMATIONS, getCampaingIfApplies, isPartOfGasDiscount, isPartOfModelsWithDiscount, isPartOfModelsWithoutDiscount } from '../../utils/constants';
import bem from '../../utils/bem';
import VideoCallButtonFlotante from '../VideoCallButtonFlotante/VideoCallButtonFlotante';
import VirtualTourContext from '../../utils/VirtualTourContext';
import { useContext } from 'react';
import { useHistory } from 'react-router-dom';

const TopInformation = ({
  title,
  subtitle,
  isLoading,
  match,
  brandUrl,
  imageUrl,
  isSummary,
  children,
  options,
  colorCode,
  leftPanel,
  rightPanel,
  leftMobilePanel,
  videoCallButton,
  videoCallOn,
  isVersionComponent,
}) => {
  const virtualTourContext = useContext(VirtualTourContext);
  const { activeCampaign } = virtualTourContext;
  const history = useHistory();

  const { tipo, modelo, version, anio, color } = match.params;
  // const shouldShowBanners = isPartOfModelsWithDiscount(modelo);
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  const isMobile = width <= 768;
  //Const to know if the top information is going to render in one customization component to put the videocall buttom in the bottom part in the mobile version
  const customizationPageMovil = !isVersionComponent && isMobile;

  function lookForResumen(e) {
    const route = document.querySelector("div.navigation-bar__next > a").href;
    const newWord = "resumen";
    const cotizador = route.split('cotizador');
    const restOfUrl = cotizador[1];
    const routeParts = restOfUrl.split("/");
    routeParts[routeParts.length - 2] = newWord;
    const newRoute = routeParts.join("/");

    history.push(newRoute);
  }

  const showGasDiscount = isPartOfGasDiscount(version, anio, activeCampaign);
  const hideDiscountBanner = isPartOfModelsWithoutDiscount(modelo);
  const overridenCampaing = getCampaingIfApplies(modelo, `${version} - ${anio}`);

  return (
    <div className="top-information">
      <div className="top-information__breadcrumbs">
        {/* <div className="top-information__brand">
          {brandUrl && !isLoading && (
            <img
              src={brandUrl}
              className="top-information__brand-image"
              alt=""
            />
          )}
          {isLoading && <div className="top-information__brand-loading" />}
        </div> */}
        <Breadcrumbs
          brandUrl={brandUrl}
          tipo={tipo}
          modelo={modelo}
          version={version}
          anio={anio}
          color={color}
          colorCode={colorCode}
          isSummary={isSummary}
        />
        <div
          className={bem('top-information__content', {
            'is-summary': isSummary,
            'is-color': leftPanel
          })}
        >
          
          {/* Se quitó este estilo del div anterior porque se quitó el botón de Video llamada del bloque superior */}
          {/*style={{ '--width-content': videoCallOn && '77rem' }}*/}

          {isSummary && (
            <div className="top-information__content-image mobile">
              <h4>{title}</h4>
            </div>
          )}
          {leftPanel}
          {isSummary && (
            <div className="top-information__content-children">{children}</div>
          )}
          <div className="top-information__content-image">
            <div className={isSummary && 'desktop'}>
              {showGasDiscount ? (
                <a id="vamoscontodo-banner" onClick={lookForResumen}>
                  <img className={"fast-banner banner1 "+title} src="https://veinsamotors.com/wp-content/uploads/2023/06/3323-BANNER-COMBUSTIBLE-01.webp" alt="Vamos con todo" />
                </a>
              ): (
                overridenCampaing ? (
                  <a id="vamoscontodo-banner" onClick={lookForResumen}>
                    <img className={"fast-banner banner1 "+title} src={overridenCampaing.stepImage} alt="Vamos con todo" />
                  </a>
                ) : (
                  !hideDiscountBanner && (
                    <a id="vamoscontodo-banner" onClick={lookForResumen}>
                      <img className={"fast-banner banner1 "+title} src="https://veinsamotors.com/wp-content/uploads/2023/07/Banner-Cotizador-Veinsa-Motors.webp" alt="Vamos con todo" />
                      <img className={"fast-banner banner2 "+title} src="https://veinsamotors.com/wp-content/uploads/2023/05/banner2.png" alt="Vamos con todo" />
                      <img className={"fast-banner banner3 "+title}  src="https://veinsamotors.com/wp-content/uploads/2023/05/banner3.png" alt="Vamos con todo" />
                      <img className={"fast-banner banner4 "+title}  src="https://veinsamotors.com/wp-content/uploads/2023/05/banner4.png" alt="Vamos con todo" />
                    </a>
                  )
                ))}

            </div>
            
            <h4 className={isSummary && 'desktop'}>{title}</h4>
            <h5>{subtitle}</h5>
            {isLoading ? (
              <div className="top-information__content-loader">
                <Skeleton circle={true} height={200} width={200} />
              </div>
            ) : (
              <>
                {isSummary ? (
                  <>
                    {options && (
                      <div className="top-information__content-navigation mobile">
                        {options}
                      </div>
                    )}
                    <div className="top-information__content-navigation--grouped">
                      {leftMobilePanel}

                      {options && (
                        <div className="top-information__content-navigation desktop">
                          {options}
                        </div>
                      )}
                      <img src={imageUrl} alt="" className={leftMobilePanel && 'desktop'} style={ANIMATIONS.fadeIn} />
                    </div>

                  </>
                ) : (
                  <>
                    {options && (
                      <div className="top-information__content-navigation mobile">
                        {options}
                      </div>
                    )}
                    {(videoCallOn && (isVersionComponent || !customizationPageMovil)) ? (
                      <>
                        <VideoCallButtonFlotante videoCall />
                        <img src={imageUrl} alt="" className={leftMobilePanel && 'desktop'} style={ANIMATIONS.fadeIn} />

                        {/* Se comentó porque se quitó el botón de Video llamada del bloque superior */}
                        {/*<div className="top-information__content-videocall desktop"> 
                          <div>
                            <img src={imageUrl} alt="" className={leftMobilePanel && 'desktop'} style={ANIMATIONS.fadeIn} />
                          </div>*/}
                          {/* videocall */}
                          {/*
                          <div className="top-information__content-videocall-button">
                            <p class="top-information__content-videocall-button-text">Solicitá una video llamada.</p>
                            {videoCallButton}
                          </div>
                        </div>*/}
                      </>
                    ) : (
                      <>
                        {/* <VideoCallButton videoCall /> */}
                        <img src={imageUrl} alt="" className={leftMobilePanel && 'desktop'} style={ANIMATIONS.fadeIn} />
                      </>
                    )}


                    {options && (
                      <div className="top-information__content-navigation desktop">
                        {options}
                      </div>
                    )}
                    {leftMobilePanel}
                    {(videoCallOn && customizationPageMovil) &&
                      <>
                        <div className="top-information__content-videocall desktop">
                          <div>
                            {/* <img src={imageUrl} alt="" className={leftMobilePanel && 'desktop'} style={ANIMATIONS.fadeIn} /> */}
                          </div>
                          <div className="top-information__content-videocall-button">
                            <p class="top-information__content-videocall-button-text">Solicitá una video llamada.</p>
                            {videoCallButton}
                          </div>
                        </div>
                      </>}
                  </>
                )}
              </>
            )}
            {!isLoading && rightPanel}
          </div>

        </div>
      </div>
    </div>
  );
};

TopInformation.propTypes = {
  brandUrl: string,
  match: object,
};

TopInformation.defaultProps = {
  showBreadcrumbs: true,
  showImage: true,
};

export default withRouter(TopInformation);
